module.exports = __webpack_public_path__ + "static/media/yacha-icon.dd261c28.png";